import { getRequest } from '../services/requestHandler';
import { Setting } from '../models';

//5537, 3 for testing
export const getSettings = async () => {
  const url = `setting/getSettings?activeOnly=true`;
  const response = await getRequest<Setting>('GetSettings', url);
  return response;
};
